(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 1293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M100.4 210.7h55.1v-27.6h-55.1v27.6zM4 45.3v27.6h248V45.3H4zm41.3 96.5h165.3v-27.6H45.3v27.6z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgFilter);

/***/ }),

/***/ 9367:
/***/ (function(module) {

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
}(this, (function () {
	var assignedElements = new Map();

	function assign(ta) {
	  if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || assignedElements.has(ta)) return;
	  var previousHeight = null;

	  function cacheScrollTops(el) {
	    var arr = [];

	    while (el && el.parentNode && el.parentNode instanceof Element) {
	      if (el.parentNode.scrollTop) {
	        arr.push([el.parentNode, el.parentNode.scrollTop]);
	      }

	      el = el.parentNode;
	    }

	    return function () {
	      return arr.forEach(function (_ref) {
	        var node = _ref[0],
	            scrollTop = _ref[1];
	        node.style.scrollBehavior = 'auto';
	        node.scrollTop = scrollTop;
	        node.style.scrollBehavior = null;
	      });
	    };
	  }

	  var computed = window.getComputedStyle(ta);

	  function setHeight(_ref2) {
	    var _ref2$restoreTextAlig = _ref2.restoreTextAlign,
	        restoreTextAlign = _ref2$restoreTextAlig === void 0 ? null : _ref2$restoreTextAlig,
	        _ref2$testForHeightRe = _ref2.testForHeightReduction,
	        testForHeightReduction = _ref2$testForHeightRe === void 0 ? true : _ref2$testForHeightRe;
	    var initialOverflowY = computed.overflowY;

	    if (ta.scrollHeight === 0) {
	      // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
	      return;
	    } // disallow vertical resizing


	    if (computed.resize === 'vertical') {
	      ta.style.resize = 'none';
	    } else if (computed.resize === 'both') {
	      ta.style.resize = 'horizontal';
	    }

	    var restoreScrollTops; // remove inline height style to accurately measure situations where the textarea should shrink
	    // however, skip this step if the new value appends to the previous value, as textarea height should only have grown

	    if (testForHeightReduction) {
	      // ensure the scrollTop values of parent elements are not modified as a consequence of shrinking the textarea height
	      restoreScrollTops = cacheScrollTops(ta);
	      ta.style.height = '';
	    }

	    var newHeight;

	    if (computed.boxSizing === 'content-box') {
	      newHeight = ta.scrollHeight - (parseFloat(computed.paddingTop) + parseFloat(computed.paddingBottom));
	    } else {
	      newHeight = ta.scrollHeight + parseFloat(computed.borderTopWidth) + parseFloat(computed.borderBottomWidth);
	    }

	    if (computed.maxHeight !== 'none' && newHeight > parseFloat(computed.maxHeight)) {
	      if (computed.overflowY === 'hidden') {
	        ta.style.overflow = 'scroll';
	      }

	      newHeight = parseFloat(computed.maxHeight);
	    } else if (computed.overflowY !== 'hidden') {
	      ta.style.overflow = 'hidden';
	    }

	    ta.style.height = newHeight + 'px';

	    if (restoreTextAlign) {
	      ta.style.textAlign = restoreTextAlign;
	    }

	    if (restoreScrollTops) {
	      restoreScrollTops();
	    }

	    if (previousHeight !== newHeight) {
	      ta.dispatchEvent(new Event('autosize:resized', {
	        bubbles: true
	      }));
	      previousHeight = newHeight;
	    }

	    if (initialOverflowY !== computed.overflow && !restoreTextAlign) {
	      var textAlign = computed.textAlign;

	      if (computed.overflow === 'hidden') {
	        // Webkit fails to reflow text after overflow is hidden,
	        // even if hiding overflow would allow text to fit more compactly.
	        // The following is intended to force the necessary text reflow.
	        ta.style.textAlign = textAlign === 'start' ? 'end' : 'start';
	      }

	      setHeight({
	        restoreTextAlign: textAlign,
	        testForHeightReduction: true
	      });
	    }
	  }

	  function fullSetHeight() {
	    setHeight({
	      testForHeightReduction: true,
	      restoreTextAlign: null
	    });
	  }

	  var handleInput = function () {
	    var previousValue = ta.value;
	    return function () {
	      setHeight({
	        // if previousValue is '', check for height shrinkage because the placeholder may be taking up space instead
	        // if new value is merely appending to previous value, skip checking for height deduction
	        testForHeightReduction: previousValue === '' || !ta.value.startsWith(previousValue),
	        restoreTextAlign: null
	      });
	      previousValue = ta.value;
	    };
	  }();

	  var destroy = function (style) {
	    ta.removeEventListener('autosize:destroy', destroy);
	    ta.removeEventListener('autosize:update', fullSetHeight);
	    ta.removeEventListener('input', handleInput);
	    window.removeEventListener('resize', fullSetHeight); // future todo: consider replacing with ResizeObserver

	    Object.keys(style).forEach(function (key) {
	      return ta.style[key] = style[key];
	    });
	    assignedElements["delete"](ta);
	  }.bind(ta, {
	    height: ta.style.height,
	    resize: ta.style.resize,
	    textAlign: ta.style.textAlign,
	    overflowY: ta.style.overflowY,
	    overflowX: ta.style.overflowX,
	    wordWrap: ta.style.wordWrap
	  });

	  ta.addEventListener('autosize:destroy', destroy);
	  ta.addEventListener('autosize:update', fullSetHeight);
	  ta.addEventListener('input', handleInput);
	  window.addEventListener('resize', fullSetHeight); // future todo: consider replacing with ResizeObserver

	  ta.style.overflowX = 'hidden';
	  ta.style.wordWrap = 'break-word';
	  assignedElements.set(ta, {
	    destroy: destroy,
	    update: fullSetHeight
	  });
	  fullSetHeight();
	}

	function destroy(ta) {
	  var methods = assignedElements.get(ta);

	  if (methods) {
	    methods.destroy();
	  }
	}

	function update(ta) {
	  var methods = assignedElements.get(ta);

	  if (methods) {
	    methods.update();
	  }
	}

	var autosize = null; // Do nothing in Node.js environment

	if (typeof window === 'undefined') {
	  autosize = function autosize(el) {
	    return el;
	  };

	  autosize.destroy = function (el) {
	    return el;
	  };

	  autosize.update = function (el) {
	    return el;
	  };
	} else {
	  autosize = function autosize(el, options) {
	    if (el) {
	      Array.prototype.forEach.call(el.length ? el : [el], function (x) {
	        return assign(x);
	      });
	    }

	    return el;
	  };

	  autosize.destroy = function (el) {
	    if (el) {
	      Array.prototype.forEach.call(el.length ? el : [el], destroy);
	    }

	    return el;
	  };

	  autosize.update = function (el) {
	    if (el) {
	      Array.prototype.forEach.call(el.length ? el : [el], update);
	    }

	    return el;
	  };
	}

	var autosize$1 = autosize;

	return autosize$1;

})));


/***/ }),

/***/ 7399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ ButtonFilterCatalog; },
/* harmony export */   "CE": function() { return /* binding */ ButtonFilterPersons; },
/* harmony export */   "UX": function() { return /* binding */ ButtonOrderingCatalog; },
/* harmony export */   "bd": function() { return /* binding */ ButtonShowMore; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1463);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function ButtonOrderingCatalog(_ref) {
  var isActive = _ref.isActive,
      callback = _ref.callback,
      children = _ref.children;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      color: isActive ? theme.colors.text : '#ccc',
      fontWeight: isActive ? 700 : 400,
      fontFamily: 'Golos',
      cursor: 'pointer',
      ':hover': {
        fontFamily: 'Montserrat',
        fontWeight: 700,
        color: theme.colors.text
      }
    },  true ? "" : 0,  true ? "" : 0),
    onClick: callback,
    type: "button",
    children: children
  });
}
function ButtonFilterCatalog(_ref2) {
  var isActive = _ref2.isActive,
      callback = _ref2.callback,
      children = _ref2.children;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      padding: 10,
      lineHeight: '5px',
      background: isActive ? '#f44336' : 'none',
      borderRadius: 3,
      color: isActive ? theme.colors.white : '#333',
      transition: 'all 0.2s ease, box-shadow 0.4s ease',
      cursor: 'pointer'
    },  true ? "" : 0,  true ? "" : 0),
    type: "button",
    onClick: callback,
    children: children
  });
}

var _ref4 =  true ? {
  name: "1jotg8x",
  styles: "width:220px;background:#ff4a2e;background-image:linear-gradient(120deg, #ff4a2e 0%, #de2839 100%);box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.25);padding:9px 25px;font-size:12px;font-weight:500;border-radius:24px;background-size:500% 500%;color:#fff;display:flex;justify-content:center;align-items:center;cursor:pointer"
} : 0;

function ButtonFilterPersons(_ref3) {
  var callback = _ref3.callback,
      children = _ref3.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    css: _ref4,
    type: "button",
    onClick: callback,
    children: children
  });
}

var _ref6 =  true ? {
  name: "wyfeef",
  styles: "width:100%;background:#dfdfdf;height:45px;border-radius:4px;padding:0 0.8em;font-size:1rem;font-family:Golos;font-weight:500;white-space:normal;border:2px solid #dfdfdf;cursor:pointer;text-decoration:none;color:#000;line-height:41px;display:inline-flex;align-items:center;justify-content:center;transition:all 0.2s ease;:hover{background:inherit;}"
} : 0;

function ButtonShowMore(_ref5) {
  var callback = _ref5.callback,
      _ref5$loadingText = _ref5.loadingText,
      loadingText = _ref5$loadingText === void 0 ? '' : _ref5$loadingText;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("button", {
    onClick: function onClick() {
      callback();
    },
    type: "button",
    css: _ref6,
    children: loadingText || 'Показать больше'
  });
}

/***/ }),

/***/ 1099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(1463);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__(9367);
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);
// EXTERNAL MODULE: ./node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(9734);
// EXTERNAL MODULE: ./lib/api/http.js
var http = __webpack_require__(1377);
// EXTERNAL MODULE: ./lib/api/urls.ts
var urls = __webpack_require__(4154);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(7135);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
// EXTERNAL MODULE: ./components/layout/Header.tsx + 15 modules
var Header = __webpack_require__(4178);
// EXTERNAL MODULE: ./components/posts/post-card.tsx
var post_card = __webpack_require__(5435);
// EXTERNAL MODULE: ./components/styled/Link.tsx
var Link = __webpack_require__(6196);
// EXTERNAL MODULE: ./components/Buttons.js
var Buttons = __webpack_require__(7399);
// EXTERNAL MODULE: ./components/Pagination.js
var Pagination = __webpack_require__(823);
// EXTERNAL MODULE: ./public/img/filter.svg
var filter = __webpack_require__(1293);
// EXTERNAL MODULE: ./public/img/check-red.svg
var check_red = __webpack_require__(9801);
// EXTERNAL MODULE: ./components/styled/typography.js
var typography = __webpack_require__(2068);
// EXTERNAL MODULE: ./utils/index.tsx
var utils = __webpack_require__(6535);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./constants/events.ts
var events = __webpack_require__(6880);
// EXTERNAL MODULE: ./lib/api/browserStorage.ts
var browserStorage = __webpack_require__(6343);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/blocks/GorbiletRecommends.tsx




function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var _ref =  true ? {
  name: "1m1lc52",
  styles: "margin-top:70px;padding-bottom:56px"
} : 0;

var _ref2 =  true ? {
  name: "qek0yg",
  styles: "font-family:Montserrat;font-weight:700;font-size:26px;margin-bottom:8px;color:#333"
} : 0;

var _ref3 =  true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0;

var _ref4 =  true ? {
  name: "eblon9",
  styles: "font-family:Golos;font-size:16px;font-weight:500;line-height:16px;color:#fff;width:260px;height:41px;background-color:#ff4a2e;background-image:linear-gradient(120deg, #ff4a2e 0%, #de2839 100%);background-size:500% 500%;animation:move-background 60s linear infinite;transition:all 0.2s ease, box-shadow 0.4s ease;border-radius:30px;margin-top:25px"
} : 0;

function GorbiletRecommends() {
  var _actions__item;

  var _useState = (0,react.useState)(null),
      recommends = _useState[0],
      setRecommends = _useState[1];

  var _useState2 = (0,react.useState)(null),
      city = _useState2[0],
      setCity = _useState2[1];

  (0,react.useEffect)(function () {
    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var cities, cityData, compilationsData, data;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http/* http.get */.d.get(urls.V3.cities, {
                  limit: consts/* CITIES_API_LIMIT */.ll
                });

              case 2:
                cities = _context.sent;
                cityData = cities.results.find(function (c) {
                  return c.url === (0,browserStorage/* getLocalStorageItem */.l)('current-city');
                }) || cities.results[0];
                _context.next = 6;
                return http/* http.get */.d.get(urls.V3.compilations.root, {
                  city: cityData.id,
                  is_gb_recommended: true
                });

              case 6:
                compilationsData = _context.sent;
                _context.next = 9;
                return http/* http.get */.d.get(urls.V4.events, {
                  ids: compilationsData.results[0].events.join(','),
                  is_web: true,
                  status: events/* activeStatus */.cT,
                  limit: 8,
                  city: cityData.id
                });

              case 9:
                data = _context.sent;
                setRecommends({
                  actions: data.results,
                  slug: compilationsData.results[0].slug
                });
                setCity(cityData);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetch.apply(this, arguments);
    }

    fetch();
  }, []);
  if (!city || !recommends) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: _ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H2, {
        css: _ref2,
        children: "\u0412\u0430\u043C \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u043E"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'flex',
          flexWrap: 'wrap',
          margin: '0 -8px',
          overflowX: 'hidden',
          '.actions__item': (_actions__item = {
            width: '25%'
          }, (0,defineProperty/* default */.Z)(_actions__item, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
            width: 'calc(100% / 3)'
          }), (0,defineProperty/* default */.Z)(_actions__item, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            width: '50%'
          }), (0,defineProperty/* default */.Z)(_actions__item, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            width: '100%',
            maxWidth: '100%'
          }), _actions__item)
        }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          width: 'unset',
          flexWrap: 'nowrap',
          flexDirection: 'column'
        }),  true ? "" : 0,  true ? "" : 0),
        children: !!recommends.actions.length && recommends.actions.map(function (action) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(post_card/* PostCard */.y, {
            item: action,
            currentCity: city
          }, action.id);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: _ref3,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: ['', city.url, 'compilations', recommends.slug, ''].join('/'),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
          type: "button",
          css: _ref4,
          children: "\u0412\u0441\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
        })
      })
    })]
  });
}
// EXTERNAL MODULE: ./providers/modal.tsx
var modal = __webpack_require__(6147);
// EXTERNAL MODULE: ./lib/api/apiUrl.ts
var apiUrl = __webpack_require__(7050);
// EXTERNAL MODULE: ./components/loader/useMainPreloader.ts
var useMainPreloader = __webpack_require__(305);
// EXTERNAL MODULE: ./components/loader/MainLoader.tsx
var MainLoader = __webpack_require__(3780);
// EXTERNAL MODULE: ./providers/loading/index.tsx
var loading = __webpack_require__(2833);
;// CONCATENATED MODULE: ./pages/search/index.js




function search_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































var search_ref3 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

var search_ref4 =  true ? {
  name: "1r71d4m",
  styles: "::first-letter{text-transform:uppercase;}"
} : 0;

var _ref5 =  true ? {
  name: "sxd4tj",
  styles: "fill:red;width:24px;height:24px;margin-right:20px"
} : 0;

var _ref6 =  true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0;

var _ref7 =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

var _ref8 =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

var _ref9 =  true ? {
  name: "w8yiws",
  styles: "color:gray"
} : 0;

var _ref10 =  true ? {
  name: "1qu8ll8",
  styles: "padding:0 8px"
} : 0;

var _ref11 =  true ? {
  name: "1e7daky",
  styles: "width:100%;display:flex;justify-content:center;align-items:center"
} : 0;

function SearchBlock(_ref) {
  var _css4, _data$searchResults3, _css6, _data$searchResults5, _data$searchResults6, _data$searchResults7;

  var showMobileSort = _ref.showMobileSort,
      sortArray = _ref.sortArray,
      setQuery = _ref.setQuery,
      query = _ref.query,
      setShowMobileSort = _ref.setShowMobileSort,
      setShowResults = _ref.setShowResults,
      searchResults = _ref.searchResults,
      showResults = _ref.showResults,
      textArea = _ref.textArea,
      textareaHandler = _ref.textareaHandler,
      searchValue = _ref.searchValue,
      currentCity = _ref.currentCity,
      setIsNewData = _ref.setIsNewData,
      isNewData = _ref.isNewData,
      setSearchResults = _ref.setSearchResults,
      routerIsLoading = _ref.routerIsLoading;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();

  var _useState = (0,react.useState)(false),
      isAdaptive = _useState[0],
      setIsAdaptive = _useState[1];

  var LIMIT_CARDS = 6;
  (0,react.useEffect)(function () {
    if (window.innerWidth <= consts/* DEVICE_SCREENS.md */.XA.md) {
      setIsAdaptive(true);
    }
  }, []);

  var getSearchResult = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var data, results, similar;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {
                searchResults: null,
                similarResults: null
              };

              if (!(query.q !== '')) {
                _context.next = 14;
                break;
              }

              _context.next = 4;
              return http/* http.get */.d.get(urls.V4.events, {
                is_web: 'true',
                city: currentCity.id,
                limit: LIMIT_CARDS,
                offset: (query.page - 1) * LIMIT_CARDS,
                ordering: query.ordering,
                status: 'active',
                q: query.q
              });

            case 4:
              results = _context.sent;

              if (isNewData) {
                setSearchResults(_objectSpread(_objectSpread({}, results), {}, {
                  results: searchResults.results.concat(results.results)
                }));
                data.searchResults = _objectSpread(_objectSpread({}, results), {}, {
                  results: searchResults.results.concat(results.results)
                });
              } else {
                setSearchResults(results);
                data.searchResults = results;
              }

              if (!(results.results.length > 0)) {
                _context.next = 13;
                break;
              }

              _context.next = 9;
              return http/* http.get */.d.get("".concat(urls.V4.baseUrl, "events/").concat(results.results[0].id, "/similar/"), {
                is_web: 'true',
                limit: 8,
                offset: 0
              });

            case 9:
              similar = _context.sent;

              if (similar.count) {
                data.similarResults = similar;
              } else {
                data.similarResults = null;
              }

              _context.next = 14;
              break;

            case 13:
              data.similarResults = null;

            case 14:
              return _context.abrupt("return", _objectSpread({}, data));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getSearchResult() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useSWR = (0,dist/* default */.ZP)(function () {
    return JSON.stringify(query);
  }, getSearchResult, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }),
      data = _useSWR.data;

  if (showMobileSort) {
    var _data$searchResults, _data$searchResults2;

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* Container */.W, {
      css: search_ref3,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography.H3, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          fontFamily: 'Montserrat',
          fontWeight: 800,
          fontSize: 22,
          color: theme.colors.text,
          padding: 16
        },  true ? "" : 0,  true ? "" : 0),
        children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          background: theme.colors.white
        },  true ? "" : 0,  true ? "" : 0),
        children: sortArray.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
            type: "button",
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              fontFamily: 'Montserrat',
              color: theme.colors.black,
              fontWeight: 700,
              fontSize: 18,
              height: 75,
              width: '100%',
              paddingLeft: 16,
              paddingTop: 30,
              display: 'inline-flex',
              justifyContent: 'space-between',
              boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.05)'
            },  true ? "" : 0,  true ? "" : 0),
            onClick: function onClick() {
              return setQuery(_objectSpread(_objectSpread({}, query), {}, {
                ordering: item.value
              }));
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: search_ref4,
              children: item.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: query.ordering === item.value && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(check_red/* default */.Z, {
                css: _ref5
              })
            })]
          }, "mobileSort-".concat(item.value));
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
        // todo вынести кнопки отдельно
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          position: 'fixed',
          left: '50%',
          zIndex: 10,
          bottom: 30,
          transform: 'translateX(-50%)',
          display: 'none',
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: 16,
          height: 36,
          color: theme.colors.white,
          padding: '9px 10px',
          lineHeight: '18px',
          backgroundImage: 'linear-gradient(120deg, #ff4a2e 0%, #de2839 100%)',
          backgroundSize: '500% 500%',
          margin: '16px 0',
          borderRadius: 20
        }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '75%'
        }),  true ? "" : 0,  true ? "" : 0),
        type: "button",
        onClick: function onClick() {
          setShowMobileSort(false);
          setShowResults(true);
        },
        children: ["\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C ", data === null || data === void 0 ? void 0 : (_data$searchResults = data.searchResults) === null || _data$searchResults === void 0 ? void 0 : _data$searchResults.results.length, ' ', (0,utils/* getEventTextFromCount */.TO)(data === null || data === void 0 ? void 0 : (_data$searchResults2 = data.searchResults) === null || _data$searchResults2 === void 0 ? void 0 : _data$searchResults2.results.length)]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          position: 'fixed',
          left: '50%',
          zIndex: 10,
          bottom: 10,
          transform: 'translateX(-50%)',
          display: 'none',
          fontFamily: 'Montserrat',
          fontWeight: 400,
          fontSize: 14,
          height: 36,
          color: theme.colors.red,
          padding: '9px 10px',
          lineHeight: '18px'
        }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '75%'
        }),  true ? "" : 0,  true ? "" : 0),
        type: "button",
        onClick: function onClick() {
          setQuery(_objectSpread(_objectSpread({}, query), {}, {
            ordering: sortArray[0].value
          }));
          setShowResults(true);
          setShowMobileSort(false);
        },
        children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C"
      })]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* Container */.W, {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css4 = {
      position: 'relative',
      width: '100%',
      maxWidth: '1280px',
      padding: '45px 120px 0',
      opacity: routerIsLoading ? 0.2 : 1
    }, (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.xxl */.fD.xxl, {
      maxWidth: '1124px',
      padding: '45px 120px 0'
    }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.xl */.fD.xl, {
      maxWidth: '960px',
      padding: '45px 53px'
    }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
      maxWidth: '720px',
      padding: '45px 8px'
    }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      maxWidth: '540px',
      padding: '45px 16px 0'
    }), (0,defineProperty/* default */.Z)(_css4, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
      maxWidth: '540px'
    }), _css4),  true ? "" : 0,  true ? "" : 0),
    children: [(data === null || data === void 0 ? void 0 : (_data$searchResults3 = data.searchResults) === null || _data$searchResults3 === void 0 ? void 0 : _data$searchResults3.count) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        position: 'fixed',
        left: '50%',
        zIndex: 10,
        bottom: 8,
        transform: 'translateX(-50%)',
        display: 'none',
        fontFamily: 'Golos',
        fontWeight: 500,
        fontSize: 16,
        height: 36,
        color: theme.colors.white,
        padding: '9px 10px',
        lineHeight: '18px',
        backgroundImage: 'linear-gradient(120deg, #ff4a2e 0%, #de2839 100%)',
        backgroundSize: '500% 500%',
        margin: '16px 0',
        borderRadius: 20
      }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '75%'
      }),  true ? "" : 0,  true ? "" : 0),
      type: "button",
      onClick: function onClick() {
        return data.searchResults.count > 0 && setShowMobileSort(true);
      },
      children: ["\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(filter/* default */.Z, {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          width: 20,
          height: 20,
          fill: theme.colors.white,
          marginLeft: 8
        },  true ? "" : 0,  true ? "" : 0)
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: _ref6,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref7,
        children: [(!showResults || !isAdaptive) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              fontWeight: 400,
              fontSize: 14,
              fontFamily: 'Golos',
              color: theme.colors.text
            },  true ? "" : 0,  true ? "" : 0),
            children: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0432\u0432\u043E\u0434\u0438\u0442\u044C \u0441\u043B\u043E\u0432\u043E"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
            action: "",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("textarea", {
              ref: textArea,
              onKeyDown: function onKeyDown(event) {
                if (event.key === 'Enter') {
                  event.preventDefault();
                }
              },
              onChange: textareaHandler,
              value: searchValue,
              placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0410\u043B\u0435\u043A\u0441\u0430\u043D\u0434\u0440\u0438\u043D\u0441\u043A\u0438\u0439 \u0442\u0435\u0430\u0442\u0440",
              maxLength: 400,
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((_css6 = {
                minHeight: 61,
                height: 61,
                resize: 'none',
                fontSize: 32,
                fontWeight: 800,
                color: '#333333',
                background: 'transparent',
                border: 'none',
                borderBottomColor: 'red',
                borderBottomStyle: 'none',
                borderBottomWidth: 'medium',
                width: '100%',
                borderBottom: '1px solid #333333',
                lineHeight: '1.6em',
                overflow: 'hidden'
              }, (0,defineProperty/* default */.Z)(_css6, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
                fontSize: 22,
                height: 40,
                minHeight: 0
              }), (0,defineProperty/* default */.Z)(_css6, '::placeholder', {
                color: 'rgba(51, 51, 51, 0.2)',
                fontWeight: 700,
                fontFamily: 'Montserrat'
              }), _css6),  true ? "" : 0,  true ? "" : 0)
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
          type: "button",
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            display: 'none',
            fontFamily: 'Golos',
            fontWeight: 500,
            fontSize: 16,
            height: 40,
            color: theme.colors.white,
            padding: '9px 10px',
            lineHeight: '18px',
            backgroundImage: 'linear-gradient(120deg, #ff4a2e 0%, #de2839 100%)',
            backgroundSize: '500% 500%',
            margin: showResults ? '-28px 0 0' : '16px 0',
            borderRadius: 4,
            opacity: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.count) > 0 ? 1 : '0.5',
            transition: 'all 0.2s ease'
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
          }),  true ? "" : 0,  true ? "" : 0),
          onClick: function onClick() {
            var _data$searchResults4;

            return (data === null || data === void 0 ? void 0 : (_data$searchResults4 = data.searchResults) === null || _data$searchResults4 === void 0 ? void 0 : _data$searchResults4.count) > 0 && setShowResults(!showResults);
          },
          children: showResults ? 'Новый поиск' : 'Показать события'
        })]
      })
    }), (data === null || data === void 0 ? void 0 : data.searchResults) && (data === null || data === void 0 ? void 0 : data.searchResults.count) === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        marginTop: 60
      }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        display: 'none'
      }),  true ? "" : 0,  true ? "" : 0),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref8,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: 26,
            textAlign: 'center',
            color: theme.colors.text
          },  true ? "" : 0,  true ? "" : 0),
          children: "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u043E\u0441\u044C"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontFamily: 'Golos',
            fontWeight: 400,
            fontSize: 14,
            textAlign: 'center',
            color: theme.colors.text
          },  true ? "" : 0,  true ? "" : 0),
          children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441."
        })]
      })
    }), (data === null || data === void 0 ? void 0 : data.searchResults) && (data === null || data === void 0 ? void 0 : data.searchResults.count) !== 0 && (showResults || !isAdaptive) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        marginTop: 20,
        marginBottom: 70
      }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        paddingBottom: 90,
        marginBottom: 0
      }),  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }, consts/* DEVICE_SCREENS_MAX_STRING.lg */.fD.lg, {
          flexDirection: 'column',
          alignItems: 'flex-start'
        }),  true ? "" : 0,  true ? "" : 0),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: 26,
            lineHeight: '31px',
            color: theme.colors.text
          },  true ? "" : 0,  true ? "" : 0),
          children: ["\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: _ref9,
            children: ["(", data === null || data === void 0 ? void 0 : data.searchResults.count, ")"]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
            display: 'flex',
            gap: 10,
            fontFamily: 'Golos',
            fontWeight: 400,
            lineHeight: '22px',
            fontSize: 12
          }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
            display: 'none'
          }),  true ? "" : 0,  true ? "" : 0),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
              color: theme.colors.text
            },  true ? "" : 0,  true ? "" : 0),
            children: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E:"
          }), sortArray.map(function (sortItem) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
              onClick: function onClick() {
                setQuery(_objectSpread(_objectSpread({}, query), {}, {
                  ordering: sortItem.value,
                  page: 1
                }));
              },
              type: "button",
              css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
                color: sortItem.value === query.ordering ? theme.colors.red : theme.colors.text
              },  true ? "" : 0,  true ? "" : 0),
              children: sortItem.title
            }, "SortButton__".concat(sortItem.title));
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_objectSpread(_objectSpread({}, theme.mixins.flex()), {}, {
          margin: '20px -8px 0 -8px'
        }),  true ? "" : 0,  true ? "" : 0),
        children: data === null || data === void 0 ? void 0 : (_data$searchResults5 = data.searchResults) === null || _data$searchResults5 === void 0 ? void 0 : _data$searchResults5.results.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(post_card/* PostCard */.y, {
            catalog: true,
            item: item,
            currentCity: currentCity
          }, item.id);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: _ref10,
        children: [(data === null || data === void 0 ? void 0 : (_data$searchResults6 = data.searchResults) === null || _data$searchResults6 === void 0 ? void 0 : _data$searchResults6.next) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* ButtonShowMore */.bd, {
          callback: function callback() {
            setIsNewData(true);
            setQuery(_objectSpread(_objectSpread({}, query), {}, {
              page: Number(query.page) + 1
            }));
          }
        }), (data === null || data === void 0 ? void 0 : (_data$searchResults7 = data.searchResults) === null || _data$searchResults7 === void 0 ? void 0 : _data$searchResults7.count) > LIMIT_CARDS && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination/* Pagination */.t, {
          currentPage: query.page - 1,
          onPrevPage: function onPrevPage() {
            return setQuery(_objectSpread(_objectSpread({}, query), {}, {
              page: Number(query.page) - 1 !== 0 ? Number(query.page) - 1 : 1
            }));
          },
          count: Math.ceil(data.searchResults.count / LIMIT_CARDS),
          onNextPage: function onNextPage() {
            return setQuery(_objectSpread(_objectSpread({}, query), {}, {
              page: Number(query.page + 1) < Math.ceil(data.searchResults.count / LIMIT_CARDS) ? Number(query.page + 1) : Math.ceil(data.searchResults.count / LIMIT_CARDS)
            }));
          },
          changePage: function changePage(event) {
            var _event$selected;

            return setQuery(_objectSpread(_objectSpread({}, query), {}, {
              page: ((_event$selected = event.selected) !== null && _event$selected !== void 0 ? _event$selected : event.currentTarget.dataset.page) + 1
            }));
          }
        })]
      })]
    }), (data === null || data === void 0 ? void 0 : data.searchResults) && !(data !== null && data !== void 0 && data.similarResults) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GorbiletRecommends, {}), (data === null || data === void 0 ? void 0 : data.searchResults) && (data === null || data === void 0 ? void 0 : data.similarResults) && (data === null || data === void 0 ? void 0 : data.similarResults.count) !== 0 && (showResults || !isAdaptive) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        marginBottom: '4rem'
      }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        marginBottom: '2rem'
      }),  true ? "" : 0,  true ? "" : 0),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          fontFamily: 'Montserrat',
          fontWeight: 700,
          fontSize: 26,
          color: theme.colors.textSecondary,
          paddingBottom: 8
        }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
          marginLeft: 8
        }),  true ? "" : 0,  true ? "" : 0),
        children: "\u041F\u043E\u0445\u043E\u0436\u0438\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        // scroll-wrapper
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
          width: '100%',
          margin: '0 -8px 0 -8px'
        }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
          width: '100%',
          '&>*': {
            whiteSpace: 'normal'
          },
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }),  true ? "" : 0,  true ? "" : 0),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(_objectSpread(_objectSpread({}, theme.mixins.flex()), {}, (0,defineProperty/* default */.Z)({
            overflow: 'auto',
            marginTop: -15,
            paddingTop: 15,
            width: '100%',
            '::-webkit-scrollbar': {
              display: 'none'
            },
            '-ms-overflow-style': 'none',
            scrollbarWidth: 'none'
          }, consts/* DEVICE_SCREENS_MAX_STRING.sm */.fD.sm, {
            flexWrap: 'nowrap'
          })),  true ? "" : 0,  true ? "" : 0),
          children: data === null || data === void 0 ? void 0 : data.similarResults.results.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(post_card/* PostCard */.y, {
              scroll: true,
              item: item,
              currentCity: currentCity
            }, item.id);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref11,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* LinkLikeButton */.Nf, {
          href: [currentCity.url, 'catalog', ''].join('/'),
          children: "\u0412\u0441\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
        })
      })]
    })]
  });
}

var __N_SSP = true;
function Page(_ref12) {
  var currentCity = _ref12.currentCity,
      cities = _ref12.cities,
      categoriesForHeader = _ref12.categoriesForHeader;
  var router = (0,next_router.useRouter)();

  var _useState2 = (0,react.useState)(null),
      searchResults = _useState2[0],
      setSearchResults = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      searchValue = _useState3[0],
      setSearchValue = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isNewData = _useState4[0],
      setIsNewData = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showResults = _useState5[0],
      setShowResults = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showMobileSort = _useState6[0],
      setShowMobileSort = _useState6[1];

  var _useMainPreloader = (0,useMainPreloader/* useMainPreloader */.Q)(),
      routerIsLoading = _useMainPreloader.routerIsLoading;

  var _useLoading = (0,loading/* useLoading */.r$)(),
      LoaderComponent = _useLoading.LoaderComponent,
      isLoading = _useLoading.isLoading;

  var textArea = (0,react.useRef)(null);

  var _useModal = (0,modal/* useModal */.dd)(),
      Modal = _useModal.Modal;

  var _useState7 = (0,react.useState)({
    ordering: '-views_per_3days',
    page: 1,
    q: ''
  }),
      query = _useState7[0],
      setQuery = _useState7[1];

  var sortArray = [{
    value: '-views_per_3days',
    title: 'популярности'
  }, {
    value: '-activated_at',
    title: 'новинкам'
  }, {
    value: 'filter_price',
    title: 'возрастанию цены'
  }, {
    value: '-filter_price',
    title: 'убыванию цены'
  }, {
    value: '-discount',
    title: 'размеру скидки'
  }];

  var onSearch = function onSearch(value) {
    var valueWithoutSpace = value.trim();

    if (valueWithoutSpace !== '') {
      setQuery(_objectSpread(_objectSpread({}, query), {}, {
        q: valueWithoutSpace,
        page: 1
      }));
      setIsNewData(false);
    } else {
      setSearchResults(false);
    }
  };

  (0,react.useEffect)(function () {
    if (query.q !== '') {
      router.replace({
        query: _objectSpread(_objectSpread({}, router.query), query)
      });
    } else {
      setSearchResults(false);
    }

    setIsNewData(false);
  }, [query]);
  (0,react.useEffect)(function () {
    var _router$query$q, _router$query$page, _router$query$orderin, _router$query$q2;

    setQuery({
      q: (_router$query$q = router.query.q) !== null && _router$query$q !== void 0 ? _router$query$q : '',
      page: (_router$query$page = router.query.page) !== null && _router$query$page !== void 0 ? _router$query$page : 1,
      ordering: (_router$query$orderin = router.query.ordering) !== null && _router$query$orderin !== void 0 ? _router$query$orderin : '-views_per_3days'
    });
    setSearchValue((_router$query$q2 = router.query.q) !== null && _router$query$q2 !== void 0 ? _router$query$q2 : '');
  }, []);
  (0,react.useEffect)(function () {
    if (textArea.current) {
      autosize_default()(textArea.current);
    }
  }, [textArea, showResults]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var debounceSearch = (0,react.useCallback)(lodash_default().debounce(onSearch, 1000), []);

  var textareaHandler = function textareaHandler(e) {
    var value = e.target.value;
    setSearchValue(value);
    debounceSearch(value);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
        children: consts/* DEFAULT_SEO_TITLE */.ye
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "description",
        content: consts/* DEFAULT_SEO_DESCRIPTION */.cz
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        charSet: "utf-8"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
        httpEquiv: "X-UA-Compatible",
        content: "IE=edge",
        "data-meta-dynamic": "true"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "canonical",
        href: "".concat(apiUrl/* GB_DOMAIN */.pJ, "/search/")
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* Header */.h, {
      currentCity: currentCity,
      cities: cities,
      categoriesForHeader: categoriesForHeader
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBlock, {
      routerIsLoading: routerIsLoading || isLoading,
      showMobileSort: showMobileSort,
      sortArray: sortArray,
      setQuery: setQuery,
      query: query,
      setShowMobileSort: setShowMobileSort,
      setShowResults: setShowResults,
      searchResults: searchResults,
      showResults: showResults,
      textArea: textArea,
      textareaHandler: textareaHandler,
      searchValue: searchValue,
      currentCity: currentCity,
      setIsNewData: setIsNewData,
      isNewData: isNewData,
      setSearchResults: setSearchResults
    }), routerIsLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainLoader/* default */.ZP, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderComponent, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal, {})]
  });
}

/***/ }),

/***/ 7646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(1099);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,5924,5675,436,4751,2068,5585,5435,2481,9774,2888,179], function() { return __webpack_exec__(7646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);